//---------------------------------------
// create changed armour-location entry
//---------------------------------------
export default function createChangedArmourLocationEntry({
  armour_location_name = '',
  id = null,
  action = '',
  payload = {},
} = {}) {
  if (!armour_location_name || !action) {
    throw new Error('Invalid input: armour_location_name and action are required')
  }

  const { hp_cur = 0 } = payload || {}
  const out = {
    armour_location_name,
    action,
  }

  if (action === 'UPDATE') {
    out.payload = {
      hp_cur,
    }
  }

  if (id != null) {
    out.id = id
  }

  return out
}
